<mat-card class="mx-2 my-2 shadow">
  <form [formGroup]="addProviderForm" (ngSubmit)="onSubmit()">
    <h5 class="content-label-each" translate>pages.newRetailer.providerInformation</h5>
    <div class="buss-info-details content-details-blk">
      <div class="row">
        
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.providerName<span class="required">*</span>
              </h4>
            </div> 
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <input
                    matInput
                    [textMask]="{ mask: charMask, guide: false }"
                    placeholder="{{'pages.AddProviders.Enterprovidername' | translate }}"
                    formControlName="providerName"
                    required
                  />
                </mat-form-field>
                <div *ngIf="f.providerName.touched && f.providerName.invalid">
                  <div *ngIf="f.providerName.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.providernameisrequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.contactName<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <input
                    matInput
                    [textMask]="{ mask: charMask, guide: false }"
                    placeholder="{{'pages.AddProviders.Entercontact' | translate }} Name"
                    [ngModel]="addProviderForm.value.contactName"
                    formControlName="contactName"
                  />
                </mat-form-field>
                <div *ngIf="f.contactName.touched && f.contactName.invalid">
                  <div *ngIf="f.contactName.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.contactnameisrequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label">
                {{'pages.ManageProviders.Mobilenumber' | translate }}<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <input
                    matInput
                    [textMask]="{ mask: phone }"
                    required
                    placeholder="{{ 'pages.newRetailer.enterMobilenumber' | translate }}"
                    formControlName="mobileNumber"
                  />
                </mat-form-field>
                <div *ngIf="f.mobileNumber.touched && f.mobileNumber.invalid">
                  <div *ngIf="f.mobileNumber.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{ 'pages.placeholders.MobileNumberisrequired' | translate }}</mat-hint
                    >
                  </div>
                  <div *ngIf="f.mobileNumber.errors.pattern">
                    <mat-hint class="text-danger ms-2"
                      >{{ 'pages.placeholders.PleaseEnter10digitMobileNumber' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.emailInput<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <input
                    matInput
                    required
                    placeholder="{{'pages.AddProviders.EnteremailAddress' | translate }}"
                    formControlName="email"
                  />
                </mat-form-field>
                <div *ngIf="f.email.touched && f.email.invalid">
                  <div *ngIf="f.email.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{ 'pages.placeholders.EmailIdisrequired' | translate }}</mat-hint
                    >
                  </div>
                  <div *ngIf="f.email.errors.pattern">
                    <mat-hint class="text-danger ms-2"> {{ 'pages.placeholders.Invalidformat' | translate }}</mat-hint>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center"
            >
              <h4 class="form-item-label" translate>
                pages.newRetailer.status<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center"
            >
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select formControlName="providerStatus" placeholder="{{'pages.AddProviders.SelectStatus' | translate }}">
                    <mat-option value="Active">Active</mat-option>
                    <mat-option value="InActive">InActive</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.address</h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <input
                    matInput
                    formControlName="address"
                    placeholder="{{'pages.AddProviders.Enteraddress' | translate }}"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.city</h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <input matInput formControlName="city" placeholder="{{'pages.AddProviders.Entercity' | translate }}" />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.state</h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-select formControlName="state" placeholder="{{'pages.AddProviders.Selectstate' | translate }}">
                    <mat-option *ngFor="let state of usStateZips" [value]="state">
                      {{ state }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row g-0">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.zipCode</h4>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="w-100" appearance="outline">
                  <input
                    matInput
                    type="text"
                    maxlength="5"
                    minlength="5"
                    placeholder="{{ 'pages.newRetailer.enterZipCode' | translate }}"
                    formControlName="zipCode"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
            </div>
      </div>
     


    
    </div>

    <div class="form-footer">
      <ul class="list-inline text-center">
        <li class="list-inline-item">
          <button
            mat-raised-button
            [disabled]="!addProviderForm.valid"
            color="primary"
            type="submit"
            class="rounded-0"
          >
            <span translate class="translate">pages.newRetailer.save</span>
          </button>
        </li>
        <li class="list-inline-item">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            class="rounded-0"
            (click)="onCancel()"
          >
            <span translate class="translate">pages.newRetailer.cancel</span>
          </button>
        </li>
        <li class="list-inline-item"></li>
      </ul>
    </div>
  </form>
</mat-card>
